import React, { forwardRef } from "react";
import "./RoadmapCard.scss";

const RoadmapCard = forwardRef(function RoadmapCard(
	{ phase, items, isActive, onClick, className = "", style = {} },
	ref
) {
	const cardClasses = `roadmap-card ${isActive ? "active" : ""} ${className}`;

	return (
		<div ref={ref} className={cardClasses} onClick={onClick} style={style}>
			<div className="roadmap-card-content">
				<h3 className="phase-title">{phase}</h3>
				<div className="roadmap-items">
					{items.map((item, index) => (
						<React.Fragment key={item}>
							<span className="roadmap-item-text">{item}</span>
							{index < items.length - 1 && (
								<span className="item-separator">
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M8.90625 19.9181L15.4263 13.3981C16.1963 12.6281 16.1963 11.3681 15.4263 10.5981L8.90625 4.07812"
											stroke="white"
											strokeWidth="1.5"
											strokeMiterlimit="10"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</span>
							)}
						</React.Fragment>
					))}
				</div>
			</div>
		</div>
	);
});

export default RoadmapCard;
